<script setup>
const content =
  'Bij de abstracte test werd u gevraagd om in een reeks figuren een patroon te ontdekken en deze op logische wijze toe te passen. <br> Deze analytische capaciteit is van belang voor functies die conceptueel complex zijn en waarvoor probleemoplossend vermogen gevraagd wordt.'
</script>

<template>
  <div class="">
    <InfoTippy :content />
  </div>
</template>
